export enum Role {
  SUPERADMIN = 1,
  COMPANY_ADMIN = 2,
}

export const allRoles = [
  {
    label: 'Superadmin',
    value: Role.SUPERADMIN,
  },
  {
    label: 'Company admin',
    value: Role.COMPANY_ADMIN,
  },
];

export function getAllRoles() {
  return [
    {
      label: 'Superadmin',
      value: Role.SUPERADMIN,
    },
    {
      label: 'Company admin',
      value: Role.COMPANY_ADMIN,
    },
  ];
}
